module.exports = __webpack_public_path__ + "static/media/related3.9af8896c.jpg";